import { WSTable } from "@wingspanhq/fe-component-library";
import {
  ListTaxWithholdingTransactionsFilterParameterStatusEq as TaxWithholdingTransactionStatus,
  TaxWithholdingTransaction,
  TaxWithholdingTransactionType
} from "@wingspanhq/wingspan-api-sdk";
import React, { useMemo } from "react";
import { columns } from "./columns";
import { selectorIsScheduledTaxPaymentCancellable } from "../../selectors/selectorIsScheduledTaxPaymentCancellable";

export type TableItemData = TaxWithholdingTransaction;

type Props = {
  items: TaxWithholdingTransaction[];
  loading?: boolean;
  onCancel?: (transaction: TaxWithholdingTransaction) => void;
};

export const TableTransactions: React.FC<Props> = props => {
  const tableData = useMemo(
    () => props.items.map(item => ({ id: item.id, data: item })),
    [props.items]
  );

  return (
    <WSTable<TableItemData>
      loading={props.loading}
      showHeader
      columns={columns}
      tableData={tableData}
      rowMenuActions={
        props.onCancel
          ? item =>
              item.data.type === TaxWithholdingTransactionType.TAX_PAYMENT &&
              item.data.status === TaxWithholdingTransactionStatus.SCHEDULED &&
              selectorIsScheduledTaxPaymentCancellable({
                quarter: item.data.quarter,
                year: item.data.year
              })
                ? [
                    {
                      label: "Cancel scheduled payment",
                      icon: "trash",
                      onClick: () => {
                        props.onCancel?.(item.data);
                      }
                    }
                  ]
                : []
          : undefined
      }
    />
  );
};
